import logo from './logo.svg';
import Home from './Main/Home';

function App() {
  return (
    <div className="App">
      <div className='Home'>
        <header className="App-header">
          <Home />
        </header>
      </div>
    </div>
  );
}

export default App;
